import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconAnalyticsBars';
/** Renders an SVG icon. */
const SvgAnalyticsBars = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M6 17v9h2v-9zm18-5v14h2V12zm-9-6v20h2V6zm4 20h3V12a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v14h1a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h1v-9a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v9h3V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"
      />
    </svg>
  );
};
SvgAnalyticsBars.displayName = displayName;
export default SvgAnalyticsBars;
